<template>
  <div style="height: 100%;line-height:1.6">
    <hshead title="开店教程" bgcolor="#fff"></hshead>
    <div class="content" style="font-size:0.24rem;padding:0.3rem">
      <p style="">
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif;font-size:0.32rem;padding:0.2rem 0;display:block">【新开店教程】</span>
      </p>
      <p style="margin-left:0;text-indent:0">
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif">1、</span>
        <span
          style="font-family: &#39;微软雅黑&#39;,sans-serif"
        >完善店铺信息，带红色*号是必填项，2、商品管理添加售卖的产品，可维护自己店铺的产品案例及描述，产品规格报价等，3、案例管理展示多种类型的作品集</span>
      </p>
      <p style="">
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif;font-size:0.32rem;padding:0.2rem 0;display:block">【店铺接单派单教程】</span>
      </p>
      <p>
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif">1</span>
        <span
          style="font-family:&#39;微软雅黑&#39;,sans-serif"
        >、交易管理任务订单中查看订单信息，2、确保店铺名下有摄影师，可定向指派摄影师接单，或公开订单让店铺名下的摄影师都能抢单接单</span>
      </p>
      <p style="">
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif;font-size:0.32rem;padding:0.2rem 0;display:block">【店铺名下摄影师加盟教程】</span>
      </p>
      <p>
        <span
          style="font-family:&#39;微软雅黑&#39;,sans-serif"
        >摄影师管理摄影师列表中添加录入摄影师信息，可做摄影师团队管理如配置摄影师等级，做约拍城市审核</span>
      </p>
      <p style="">
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif;font-size:0.32rem;padding:0.2rem 0;display:block">【订单退款教程】</span>
      </p>
      <p>
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif">交易管理任务订单中查看任务信息，任务信息中可操作订单退款</span>
      </p>
      <p style="">
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif;font-size:0.32rem;padding:0.2rem 0;display:block">【长期合作客户管理教程】</span>
      </p>
      <p>
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif">客户管理协议管理中添加录入客户信息，让协议客户享受优惠价</span>
      </p>
      <p style="">
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif;font-size:0.32rem;padding:0.2rem 0;display:block">【用户点评维护教程】</span>
      </p>
      <p>
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif">店铺管理点评管理中查看点评信息，可审核点评是否在外网显示，可回复用户点评</span>
      </p>
      <p style="">
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif;font-size:0.32rem;padding:0.2rem 0;display:block">【客户服务教程】</span>
      </p>
      <p>
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif">在去拍拍管家公众号或管家网页版中的客户管理用户咨询中在线交流</span>
      </p>
      <p style="">
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif;font-size:0.32rem;padding:0.2rem 0;display:block">【跟进客户教程】</span>
      </p>
      <p>
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif">客户管理酒店管理中跟进有提交订单尝试下单的客户</span>
      </p>
      <p style="">
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif;font-size:0.32rem;padding:0.2rem 0;display:block">【平台帮店铺开发票教程】</span>
      </p>
      <p>
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif">联系平台运营提交开票需求，平台收取开票税金等费用，统一每周三开票一次</span>
      </p>
      <p style="">
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif;font-size:0.32rem;padding:0.2rem 0;display:block">【店铺提现教程】</span>
      </p>
      <p style="">
        <span style="font-family:&#39;微软雅黑&#39;,sans-serif">去拍拍管家移动端收益板块中点击我要提现</span>
      </p>
      <p>
        <br />
      </p>
    </div>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";

export default {
  name: "course",
  data() {
    return {};
  },
  components: {
    hshead
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.product-ul {
  background-color: #eef2f5;
  padding: 0.25rem (7.5-6.94rem)/2;
  padding-bottom: 1rem;
  .product-li {
    width: 6.94rem;
    height: 2.2rem;
    background-color: #ffffff;
    border-radius: 0.1rem;
    display: flex;
    margin-bottom: 0.25rem;
    .left-img {
      width: 2.2rem;
    }
    .center-p {
      width: 3.37rem;
      padding-left: 0.17rem;
      padding-top: 0.4rem;
      .center-top {
        font-family: PingFang-SC-Bold;
        font-size: 0.3rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.45rem;
        letter-spacing: 0rem;
        color: #333333;
        display: flex;
        .img-box {
          width: 0.32rem;
          height: 0.32rem;
          background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
            linear-gradient(#e2bebf, #e2bebf);
          background-blend-mode: normal, normal;
          border-radius: 50%;
          overflow: hidden;
          margin-top: 0.05rem;
          margin-right: 0.2rem;
          img {
            width: 100%;
          }
        }
        .this-p {
          flex: 1;
          font-family: PingFang-SC-Bold;
          font-size: 0.26rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.45rem;
          letter-spacing: 0rem;
          color: #333333;
          margin-bottom: 0.2rem;
          span {
            color: #999999;
          }
        }
      }
      .center-pri {
        height: 0.29rem;
        font-family: PingFang-SC-Medium;
        font-size: 0.28rem;
        font-weight: bold;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #ff3087;
        padding-left: 0.3rem;
      }
      .del-pri {
        height: 0.29rem;
        font-family: PingFang-SC-Medium;
        font-size: 0.2rem;
        font-weight: bold;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #999;
        text-decoration: line-through;
        padding-left: 0.3rem;
      }
    }
    .right-btn-box {
      flex: 1;
      margin-right: 0.3rem;
      .right-btn {
        width: 1.36rem;
        height: 0.4rem;
        background-color: #00b8f5;
        border-radius: 0.2rem;
        border: solid 1px #00b8f5;
        color: #ffffff;
        font-family: PingFang-SC-Medium;
        font-size: 0.22rem;
        line-height: 0.4rem;
        display: block;
        text-align: center;
        margin-top: 0.5rem;
        &.nobg {
          color: #00b8f5;
          background-color: #fff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/Course.vue